<template>
  <div class="footer_banner_section">
    <div class="footer_banner_content">
      <h2 class="footer_banner_heading">
        {{ shopifyData.footerTitle }}
      </h2>
      <div class="footer_banner_description_wrapper">
        <div
          ref="footerDescription"
          class="footer_banner_description"
          :class="{ collapsed: shouldTruncate && !showFullContent }"
          v-html="shopifyData.footerContent"
        />
        <button
          v-if="shouldTruncate"
          class="readMoreButton"
          :aria-expanded="showFullContent"
          @click="toggleContent"
        >
          {{ showFullContent ? 'Read Less' : 'Read More' }}
        </button>
      </div>
    </div>
  </div>
  <!-- FAQ Section -->
  <div v-if="!shopifyData.isHiddenFaq" class="faq-section">
    <h2 class="faq-heading">{{ shopifyData.faqTitle }}</h2>
    <div v-for="(faq_item, index) in shopifyData.faqItems" :key="index" class="faq-item">
      <button class="faq-question" aria-label="Toggle FAQ Answer" @click="toggleAnswer(index)">
        <span class="faq-icon" :class="{ expanded: shownAnswerIndex === index }">
          <svg
            v-if="shownAnswerIndex !== index"
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M7 1V13M1 7H13" stroke="black" stroke-width="1.5" stroke-linecap="square" />
          </svg>
          <svg
            v-else
            width="14"
            height="2"
            viewBox="0 0 14 2"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M1 1H13" stroke="black" stroke-width="1.5" stroke-linecap="square" />
          </svg>
        </span>
        <span class="faq-question-text">{{ faq_item.question }}</span>
      </button>
      <div v-if="shownAnswerIndex === index" class="faq-answer">
        {{ faq_item.answer }}
      </div>
    </div>
  </div>
  <!-- Footer Banner Section End -->
</template>

<script>
import { sanitizeHtml } from '@/sanitizeContent.js';
export default {
  props: {
    shopifyData: {
      type: Object,
      required: true,
      sanitizeHtml,
    },
  },
  data() {
    return {
      shownAnswerIndex: 0,
      shouldTruncate: false,
      showFullContent: false,
    };
  },
  computed: {},

  watch: {
    'shopifyData.footerContent'() {
      this.$nextTick(this.checkFooterContent);
    },
  },
  mounted() {
    console.log('shopifyData', this.shopifyData);
    this.checkFooterContent();
  },

  methods: {
    toggleContent() {
      this.showFullContent = !this.showFullContent;
    },
    checkFooterContent() {
      const paragraphs = this.$refs.footerDescription?.querySelectorAll('p');
      this.shouldTruncate = paragraphs?.length > 1 && paragraphs[1].textContent.trim().length > 0;
      this.showFullContent = false;
    },
    toggleAnswer(index) {
      this.shownAnswerIndex = this.shownAnswerIndex === index ? -1 : index;
    },
  },
};
</script>

<style scoped>
/* Footer Banner Section CSS */
.footer_banner_section {
  background: #ffffff;
  display: flex;
  gap: 12px;
  align-items: flex-start;
  flex-direction: column;
  max-width: 973px;
  margin: 60px auto 0;
}

.footer_banner_content {
  margin: 0 auto;
  width: 100%;
}

.footer_banner_heading {
  font-family: 'Helvetica Neue', sans-serif;
  font-weight: 700;
  font-size: 15px;
  line-height: 18px;
  letter-spacing: 0.3px;
  color: #000000;
  margin: 0 0 24px 0;
  text-transform: uppercase;
  width: 100%;
}

.footer_banner_description {
  font-family: 'adobe-caslon-pro', serif !important;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  color: #000000;
  margin: 0 0 20px 0;
  transition: all 0.3s ease;
}

.footer_banner_description :deep(p) {
  margin: 0 !important;
}

.footer_banner_description :deep(p + p) {
  margin-top: 12px !important;
}

.footer_banner_description.collapsed :deep(p:nth-of-type(n + 2)) {
  display: none;
}

.readMoreButton {
  background: none;
  border: 0;
  padding: 0;
  font-family: 'adobe-caslon-pro', serif;
  font-size: 16px;
  text-align: end;
  width: 100%;
  cursor: pointer;
}

.footer_banner_description.footer_banner_rich_content {
  margin-left: 20px;
}

.footer_banner_description :deep(*) {
  font-family: 'adobe-caslon-pro', serif !important;
  font-size: 16px;
  line-height: 1.5;
}

/* Footer Banner Responsive */
@media (max-width: 768px) {
  .footer_banner_section {
    padding: 30px 15px;
    margin: 20px 0 0 0;
  }

  .footer_banner_heading {
    font-size: 14px;
    line-height: 17px;
    margin-bottom: 15px;
  }

  .footer_banner_description {
    font-size: 13px;
    line-height: 18px;
  }

  .footer_banner_description :deep(*) {
    font-size: 14px;
  }

  .readMoreButton {
    font-size: 14px;
  }
}

/* FAQ Section Styles */
.faq-section {
  max-width: 973px;
  margin: 20px auto 80px;
}

.faq-heading {
  font-family: 'Helvetica Neue', Arial, sans-serif;
  font-weight: 700;
  font-size: 15px;
  line-height: 18px;
  letter-spacing: 0.3px;
  text-transform: uppercase;
  color: #000000;
  margin: 0 0 12px 0;
  text-align: left;
}

.faq-item {
  border-bottom: 1px solid #dadada;
  padding: 0;
}

.faq-question {
  background: none;
  border: none;
  width: 100%;
  text-align: left;
  padding: 16px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  font-family: 'Helvetica Neue', Arial, sans-serif;
  font-weight: 700;
  font-size: 14px;
  line-height: 17px;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  color: #000000;
  transition: all 0.3s ease;
}

.faq-question:hover {
  opacity: 0.7;
}

.faq-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  flex-shrink: 0;
  margin-right: 12px;
}

.faq-icon svg {
  transition: all 0.3s ease;
}

.faq-question-text {
  flex: 1;
  text-align: left;
}

.faq-answer {
  font-family: 'adobe-caslon-pro', serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  color: #000000;
  padding: 0 24px 20px 36px;
  animation: fadeIn 0.3s ease;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Responsive styles for FAQ */
@media (max-width: 992px) {
  .faq-section {
    margin: 0px auto 60px;
    padding: 0 15px;
  }

  .faq-heading {
    font-size: 15px;
    line-height: 18px;
    margin-bottom: 20px;
  }

  .faq-question {
    font-size: 12px;
    line-height: 18px;
    padding: 15px 24px 15px 0px;
  }

  .faq-answer {
    font-size: 14px;
    line-height: 20px;
    padding: 0 24px 15px 36px;
  }
}
</style>
